export const RandomImageSrc = (width: number, height: number): string => {
  const randomId = Math.floor(Math.random() * 100) + 1;
  return `https://picsum.photos/id/${randomId}/${width}/${height}`;
};
